import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Modal, SpeakerPopup } from "components";
import { Leaf } from "images/svgs";

const Speaker = ({ data, speakers }) => {
  const speakerImage = getImage(data.image);
  return (
    <Modal
      trigger={
        <StyledCard>
          <CardImgContainer>
            <SVGContainer>
              <Leaf />
            </SVGContainer>
            <CardImg image={speakerImage} alt={data.name} />
          </CardImgContainer>
          <CardTitle>{data.name}</CardTitle>
          <CardSubtitle>{data.title}</CardSubtitle>
          <CardFooter>
            <div style={{ alignSelf: "center" }}>
              <CardButton>Read More</CardButton>
            </div>
          </CardFooter>
        </StyledCard>
      }
      modalContent={<SpeakerPopup startPoint={data.id - 1} speakers={speakers} />}
    />
  );
};

const CardImgContainer = styled(motion.div)`
  background: #fff;
  filter: none;
  left: 50%;
  max-width: 285px;
  overflow: hidden;
  padding-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 50px;
  position: relative;
  transform: translateX(-50%);
  transition-duration: 1s;
  overflow: visible;
  z-index: 1;
`;

const CardImg = styled(GatsbyImage)`
  border-radius: 50%;
  cursor: pointer;
  margin-bottom: 1.25rem;
  object-fit: cover;
  object-position: center;
  position: relative;
  transition: 0.5s;
  z-index: 1;
  overflow: visible;
  &:before {
    content: "";
    position: absolute;
    bottom: -4px;
    right: -4px;
    width: 100%;
    height: 100%;
    background: rgba(3, 147, 44, 0.3);
    border-radius: 50%;
    z-index: 0;
  }
`;

const CardTitle = styled.h3`
  color: var(--abbvie-green);
  font-family: "League Spartan", sans-serif;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 0px;
  margin-top: 0px;
  text-align: center;
`;

const CardSubtitle = styled.p`
  color: var(--abbvie-blue);
  font-family: "League Spartan", sans-serif;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  margin: 0 auto;
  max-width: 50%;
  text-align: center;
`;

const StyledCard = styled(motion.div)`
  display: flex;
  flex-direction: column;
  height: 100%;
  transition-duration: 0.375s;
  font-family: "League Spartan", sans-serif;
  width: 100%;
  &:hover ${CardImg} {
    box-shadow: 0px 0.375rem 0.75rem rgba(0, 0, 0, 0.25);
    filter: none;
  }
`;

const CardFooter = styled.div`
  margin-top: auto;
`;

const CardButton = styled.div`
  align-items: center;
  background-color: transparent;
  color: var(--abbvie-green);
  font-family: "League Spartan", sans-serif;
  cursor: pointer;
  display: flex;
  font-size: 1rem;
  font-weight: 700;
  height: 3rem;
  justify-content: center;
  text-transform: uppercase;
  transition: 0.5s;
  width: 100%;
  @media (min-width: 1150px) {
    justify-content: center;
  }
`;

const SVGContainer = styled.div`
  position: absolute;
  left: -4%;
  top: 17%;
  width: 55%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
  svg {
    height: 100%;
    width: 100%;
  }
`;

export default Speaker;
